export default __webpack_public_path__ + "static/media/ActiveTableIcon.16cde92a.svg";